import axios from 'axios';
import { getSubdomain } from '../utils/subdomain';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3000',
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

// Add a request interceptor
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Tell the backend which workspace this request belongs to.
    // BaseController validates this against the authenticated user's org.
    const subdomain = getSubdomain() || process.env.REACT_APP_ORGANIZATION_SUBDOMAIN;
    if (subdomain) {
      config.headers['X-Organization-Subdomain'] = subdomain;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor
let isRedirecting = false;

api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle profile completion required
    if (error.response?.status === 403 && 
        error.response?.data?.redirect_to === 'profile_completion') {
      // Prevent multiple redirects
      if (!isRedirecting && window.location.pathname !== '/complete-profile') {
        isRedirecting = true;
        window.location.href = '/complete-profile';
      }
    }
    return Promise.reject(error);
  }
);

export default api;